<template>
    <div
        :data-component-name="$options.name"
    >
        <!-- {{ queryVariables }} -->
<!-- {{ hasError }} -->
        <div v-if="isButton">
            <q-btn color="primary" size="sm" :label="isButton" no-caps outline @click.stop="$refs.qResourceTrackingProxy.show()" class="q-mb-xs" icon="add_circle" icon-right="arrow_drop_down">
            </q-btn>
        </div>
        <q-field dense placehoder="Non assigné" icon="add" v-else>
            <div class="o-item-with-error">
                <q-icon class="o-item-with-error-icon" name="error" v-if="hasError && hasError.type=='RESOURCEASSIGNMENTCONFLICT'">
                    <q-tooltip>
                        Cet ressource est assignée à plus d'un quart de travail pendant cette période
                    </q-tooltip>
                </q-icon>
                <q-icon class="o-item-with-error-icon" name="do_not_disturb_on_total_silence" v-if="hasError && hasError.type=='RESOURCEABSENCECONFLICT'">
                    <q-tooltip>
                        Cet ressource est indisponible pendant au moins une journée pour cette période
                    </q-tooltip>
                </q-icon>
                <q-icon class="o-item-with-warning-icon" name="hourglass_bottom" v-if="hasDraft">
                    <q-tooltip>
                        Cette information n'est pas publiée
                    </q-tooltip>
                </q-icon>
            </div>
            <template v-slot:append>
                <q-icon name="arrow_drop_down"
                    v-if="!accessLevel.isLimited"
                />
            </template>
            <template v-slot:prepend>
                <q-icon name="delete_outline" color="" class="cursor-pointer" style="align-self: start; padding-top: 9px;"
                    @click.stop="$emit('remove-resource')"
                    v-if="(!accessLevel.isLimited || !$attrs.value) && resource"
                />
            </template>

            <template v-slot:control>
                <div v-if="resource">
                    <div  class="input-style row items-center">
                        {{ resource.name }}
                        <UserProfileInfo defaultTab="schedule" forceType="Resource" :currentDate="firstDate" :userProfile="resource" class="q-mr-xs q-ml-xs" @click.stop.prevent />
                    </div>
                    <div class="full-width">
                        <div>
                            <small v-if="resource.isUserVehicule && resource.userProfile" style="" class="">
                                <strong>
                                    <q-icon name="person" />
                                    {{ resource.userProfile.name }}
                                </strong>
                                (véhicule du personnel)
                            </small>
                        </div>
                        <div>
                            <small v-if="resource.description" style="" class="">
                                {{ resource.description }}
                            </small>
                        </div>
                    </div>

                </div>
                <div v-else class="input-style text-red">Ajouter une ressource</div>
            </template>
            
        </q-field>
        <q-popup-proxy content-class="bestcandidate-wrapper" ref="qResourceTrackingProxy" transition-show="scale"
            transition-hide="scale" @show="search(null)" v-if="!accessLevel.isLimited">
            <div class="-header">
                <q-input borderless dark type="text" placeholder="Rechercher" autofocus v-model="searchText" debounce="500">
                    <template v-slot:prepend>
                        <q-spinner v-if="($apollo.queries.resources && $apollo.queries.resources.loading) || loading" />
                        <q-icon name="search" v-else />
                    </template>
                </q-input>
            </div>
            <div class="-footer">
                <div class="buttons-wrapper">
                    <q-radio size="24px" v-model="availability" val="available" label="Dispo."
                        @input="availability = 'available'" />
                    <q-radio size="24px" v-model="availability" val="unavailable" label="Non dispo."
                        @input="availability = 'unavailable'" />
                    <q-radio size="24px" v-model="availability" val="all" label="Tous" @input="availability = 'all'" />
                    <div class="-splitter">
                    </div>
                    <div style="display: flex;" class="">
                        <select v-model="selectedResourceTypes" class="input-style q-px-xs -select-type-filter"
                            style="max-width: 120px;">
                            <option :value="null">Tous les types</option>
                            <option v-for="(type, rti) in resourceTypesList" :key="rti" :value="type.id">{{ type.name }}
                            </option>
                        </select>
                    </div>
        
                </div>
            </div>
        
        
            <div class="-content">
                <div class="bestCandidate-row" :key="index" v-for="(fresource, index) in resources"
                    @click="$refs.qResourceTrackingProxy.hide(); $emit('input', fresource)">
                    <div>
                        <div class="bestCandidate-row-top q-py-xs2">
                            <!-- {{ fresource }} -->
                            <div class="right">
                                <div>{{ fresource.name }}
                                    <UserProfileInfo defaultTab="schedule" forceType="Resource" :currentDate="firstDate" :userProfile="fresource"
                                        class="q-ml-sm" @click.stop.prevent />
                                </div>
                                <div v-if="!fresource.isUserVehicule">
                                    <small v-if="fresource.type" style="font-weight:800;" class="text-green">
                                        {{ fresource.type.name }}
                                    </small>
                                </div>
                                <div v-else>
                                    <small v-if="fresource.type" style="font-weight:800;" class="text-green">
                                        Véhicule personnel
                                    </small>
                                </div>
                                <div>
                                    <small v-if="fresource.isUserVehicule && fresource.userProfile" style="" class="">
                                        {{ fresource.userProfile.name }}
                                    </small>
                                </div>
                                <div>
                                    <small v-if="fresource.description" style="" class="">
                                        {{ fresource.description }}
                                    </small>
                                </div>
                            </div>
                            <div class="left">
                                <div class="-meta">
                                    <small v-if="fresource.relevancy">
                                        <div title="Pertinence du résultat">
                                            {{ fresource.relevancy.toFixed(2) }}
                                            <q-icon name="show_chart" />
                                        </div>
        
                                    </small>
                                </div>
                                <div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        
        
        </q-popup-proxy>
        <!-- {{ availableStaffVehicules }} -->
    </div>
</template>

<script>

import { RESOURCESTRACKINGSEARCH, RESOURCETYPES } from '@/graphql/resource/queries'
// import moment from 'moment';

export default {
        name: 'ResourceTrackingInput',
        //components: { Component1, Component2 },
        props: {
            variables: {
                type: Object,
                default() {
                    return {
                    }
                }
            },
            resource: {
                type: Object,
                default() {
                    return null
                }
            },
            hasError: {
                type: [Object],
                default() {
                    return null
                }
            },
            hasDraft: {
                type: Boolean,
                default: false,
            },
            accessLevel: {
                type: [Object],
                default() {
                    return null
                }
            },
            initialResourceType: {
                type: [String, Number],
                default() {
                    return null
                }
            },
            availableStaffVehicules: {
                type: Array,
                default() {
                    return []
                }
            },
            isButton: {
                type: [String],
                default() {
                    return null
                }
             }
        },
        data(){
        	return {
                searchText: null,
                resources: [],
                availability: 'available',
                selectedResourceTypes: null,
                loading: true,
                searchTO: {},
                firstDate: null,
        	}
        },
        mounted(){
            if(this.variables.dates?.length>0){
                this.firstDate=this.variables.dates[0].from
            }
            if(this.initialResourceType) this.selectedResourceTypes=this.initialResourceType;
            // if(!this.variables.resourceTypes) this.variables.$set('resourceTypes', []);
        },
        computed: {
            queryVariables(){
                // this.setLoading();
                return { ...this.variables, availability: this.availability, search: this.searchText} 
            },
            resourceTypesList(){
                let resourceTypesList = [];

                if(this.resourceTypes && this.resourceTypes.length>0){
                    this.resourceTypes.forEach(function(resourceType){
                        resourceTypesList.push({
                            id: resourceType.id,
                            name: resourceType.name
                        })
                    })
                }

                if(this.availableStaffVehicules && this.availableStaffVehicules.length>0) {
                    resourceTypesList.push({
                        id: 'staffVehicules',
                        name: 'Véhicules personnels'
                    })
                }

                return resourceTypesList;
            }
        },
        watch: {
            // searchText(val, oldval) {
            // },
        },
        methods: {
            search(){

                if (this.$apollo.queries.resourceTrackingSearch) return;

                this.$apollo.addSmartQuery('resourceTrackingSearch', {
                    query: RESOURCESTRACKINGSEARCH,
                    fetchPolicy: 'no-cache',
                    // debounce: 500,
                    watchLoading(isLoading) {
                        this.loading = isLoading;
                    },
                    notifyOnNetworkStatusChange: true,
                    variables(){
                        return {
                            ...this.queryVariables,
                            resourceTypes: (this.selectedResourceTypes) ? [this.selectedResourceTypes] : null
                        }
                    },
                    update(data){
                        this.resources = [];

                        if (data.resourcesTrackingSearch) {
                            data.resourcesTrackingSearch.forEach(function(item){
                                this.resources.push( {...item})
                            }.bind(this))
                        }

                        if (this.selectedResourceTypes && this.selectedResourceTypes.includes('staffVehicules')) {
                            this.resources = this.availableStaffVehicules;
                        }
                    }
                })
            }
        },

        apollo: {
            resourceTypes: {
                query: RESOURCETYPES,
                fetchPolicy: 'cache-first',
                error(error) {
                    if (error.message) this.$q.notify({ type: 'negative', message: "Oh Oh", caption: error.message });
                },
                update(resourceTypes) {
                    this.resourceTypes = resourceTypes.resourceTypes;
                    return this.resourceTypes;
                }
            }
        }
    }
</script>

<style lang="scss">
    .assignment-remove {
        color: lightgrey;

        &:hover {
            color: darkgrey;
            cursor: pointer;
        }
    }

    body .bestcandidate-wrapper {
        background-color: $color-1-darkest; //toDo : variable pour le dark?
        min-width: 400px;
        width: 400px;
        min-height: 450px;
        max-height: 550px;
        display: flex;
        flex-direction: column;

        & .bestCandidate-row {
            line-height: 1.2rem;
            & > div {
                padding: 10px 30px;
                border-bottom: 1px solid $color-1;
            }

            &:hover{
                cursor: pointer;
                background-color: $color-1-darker; //toDo : variable pour le dark?
            }

            &-top{
                display: flex;
                flex-direction: row;
                
                & .right {
                    flex-grow: 1;

                    small {
                        margin-right: 8px;
                    }
                }

                & .left {
                    text-align: right;
                    div {
                        white-space: nowrap;
                        flex-flow: row;
                    }

                    .-meta {
                        opacity: 0.5
                    }
                }
            }
        }

        & .-content {
            flex-grow: 1;
            padding: 0px 0;
            padding-bottom: 10px;
            overflow: hidden;
            overflow-y: auto;
            color: white;
        }
        & .-header, & .-footer {
            background-color: $color-1-dark; //toDo : variable pour le dark?
            padding: 0 30px;
            border-bottom: 1px solid $color-1;
        }
        // & .-header {
            // border-bottom: 1px solid $color-1;
        // }
        & .-footer {
            border-top: 1px solid $color-1-darkest;
            padding: 6px 16px;
            color: white;
            // background-color: $color-1-darkest; //toDo : variable pour le dark?
            & .buttons-wrapper{
                display: flex;
                flex-direction: row;
                justify-content: space-evenly;
                font-size: 0.85rem;

                .-splitter {
                    border-left: 1px solid $color-1;
                    width: 1px;
                    max-width: 1px
                }
            }
        }

        & .q-radio__inner--falsy {
            color: white;
        }

        .-select-type-filter {
            background-color: transparent;
            color: white;
            border: 1px solid $color-1;
            border-radius: 4px;
            font-weight: 500;
            outline: none;
            font-size: 0.85rem;
            option {
                color:black;
            }
        }
    }
</style>
